import * as React from 'react'
export function useCounter() {
  var _a = React.useState(0),
    counter = _a[0],
    setCounter = _a[1]
  return [
    counter,
    function () {
      return setCounter(function (c) {
        return c + 1
      })
    },
  ]
}
//# sourceMappingURL=useCounter.js.map
